module.exports = __webpack_public_path__ + "static/media/LoanOfficer.dbd2a83b.svg";